import './vendor.ts';

import { NgModule } from '@angular/core';
import { Router } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { Ng2Webstorage } from 'ng2-webstorage';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedModule, UserRouteAccessService } from './shared';
import { LoginModule } from './login/login.module';
import { HomeModule } from './home/home.module';

import { LayoutRoutingModule } from './layouts';
import { customHttpProvider } from './blocks/interceptor/http.provider';
import { PaginationConfig } from './blocks/config/uib-pagination.config';

import { BaseDataModule } from './base-data/base-data.module';
import { EmployeeModule } from './employee/employee.module';
import { EvaluationModule } from './evaluation/evaluation.module';
import { AdministrationModule } from './administration/administration.module';

import {
  MainComponent,
  HeaderComponent,
  FooterComponent,
  ProfileService,
  PageRibbonComponent,
  // ActiveMenuDirective,
  ErrorComponent
} from './layouts';

import { SidebarComponent } from './layouts/sidebar/sidebar.component';
import { MarketsModule } from './markets/markets.module';
import { MyDateRangePickerModule } from 'mydaterangepicker';
import { MyDatePickerModule } from 'mydatepicker';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { OrderModule } from 'ngx-order-pipe';
import { AngularOpenlayersModule } from 'ngx-openlayers';
import { LogsModule } from './logs';
import { ExpenseModule } from './expense';
import { MessagesModule } from './messages';
import { AgmCoreModule } from '@agm/core';
import { DocumentsModule } from 'app/documents';
import {NewsModule} from './news/news.module';

@NgModule({
  imports: [
    BrowserModule,
    Ng2Webstorage.forRoot({ prefix: '', separator: '-'}),
    NgbModule.forRoot(),
    SharedModule,
    LoginModule,
    HomeModule,
    BaseDataModule,
    MarketsModule,
    EmployeeModule,
    EvaluationModule,
    AdministrationModule,
    LogsModule,
    LayoutRoutingModule,
    MyDateRangePickerModule,
    MyDatePickerModule,
    NgxDatatableModule,
    OrderModule,
    AngularOpenlayersModule,
    ExpenseModule,
    MessagesModule,
    DocumentsModule,
    NewsModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBwUC5Zhll-DNN34HLfoaNQaKF2ByqNcWU'
    }),
  ],
  declarations: [
    MainComponent,
    HeaderComponent,
    ErrorComponent,
    PageRibbonComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent
  ],
  providers: [
    ProfileService,
    customHttpProvider(),
    PaginationConfig,
    UserRouteAccessService
  ],
  bootstrap: [ MainComponent ]
})
export class AppModule {
  constructor(router: Router) {
    // console.log('Routes: ', JSON.stringify(router.config, undefined, 2));
  }
}




// WEBPACK FOOTER //
// ./src/app/app.module.ts